import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { ProgressReportTasks } from "./routes";
export default store => ({
  path: "reporttasks",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "progress-report" */ "./components"),
        import(
          /* webpackChunkName: "progress-report" */ "./modules/AdminProgressReportsModule"
        ),
        import(
          /* webpackChunkName: "progress-report" */ "ProgressReport/modules/ProgressReportModule"
        ),
        import(
          /* webpackChunkName: "progress-report" */ "./components/GenerateReportTaskGroupModalV2/modules/GenerateReportTaskGroupModalModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const reportModule = importedModule2.default;
          const generateReportTaskGroupModalModule = importedModule3.default;
          injectReducer(store, {
            key: "adminProgressReport",
            reducer,
          });
          injectReducer(store, {
            key: "progressReport",
            reducer: reportModule,
          });
          injectReducer(store, {
            key: "generateReportTaskGroupModal",
            reducer: generateReportTaskGroupModalModule,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ProgressReportTasks(store)],
});
